import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./RoleCardTitle.scss";

const TeamRoleCardTitle = ({ description = "", title, isSelected = false }) => (
    <div className="role-card-title">
        <div className="role-card-title__content">
            <div className="role-card-title__icon">
                <Icon type="FontAwesome" glyph="users-duotone" />
            </div>
            <div className="role-card-title__text">
                <p className="-type--large">
                    <span className="-type--large">{title}</span>{" "}
                    {!isSelected && (
                        <span className="-type--small -vertical-align--top">
                            <Icon
                                glyph="chevron-right-solid"
                                type="FontAwesome"
                            />
                        </span>
                    )}
                    {description && (
                        <>
                            <br />
                            {isSelected && (
                                <Icon
                                    className="-margin-right--10 -color--system-medium-dark"
                                    glyph="crown-regular"
                                    type="FontAwesome"
                                />
                            )}

                            <span className="-type--small -color--system-medium-dark">
                                {description}
                            </span>
                        </>
                    )}
                </p>
            </div>
        </div>
    </div>
);

TeamRoleCardTitle.propTypes = {
    description: PropTypes.string,
    isSelected: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TeamRoleCardTitle;
